import { useEffect, useState, useContext } from "react";
import { useSearchParams } from "react-router-dom";
import { SessionContext } from "../context/SessionContext";
import { format } from "date-fns";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Pagination from "../components/Pagination";
import PageLoader from "../components/PageLoader";
import Empty from "../components/Empty";

const Logs = () => {
	const [session] = useContext(SessionContext);
	const [logs, setLogs] = useState([]);
	const [meta, setMeta] = useState(null);
	const [searchParams, setSearchParams] = useSearchParams({});
	const [loading, setLoading] = useState(false);
	const [filtermodal, setFilterModal] = useState(false);

	const [searchQ, setSearchQ] = useState(searchParams.get("q") || "");
	const [searchGroup, setSearchGroup] = useState(
		searchParams.get("group") || ""
	);
	const [searchType, setSearchType] = useState(searchParams.get("type") || "");
	const [searchDate, setSearchDate] = useState(searchParams.get("date") || "");

	const searchFields = [
		{ key: "q", value: searchQ },
		{ key: "group", value: searchGroup },
		{ key: "type", value: searchType },
		{ key: "date", value: searchDate },
	];

	const filterFields = [
		{
			key: "group",
			value: searchGroup,
			defaultVal: "",
			edit: setSearchGroup,
		},
		{
			key: "type",
			value: searchType,
			defaultVal: "",
			edit: setSearchType,
		},
		{
			key: "date",
			value: searchDate,
			defaultVal: "",
			edit: setSearchDate,
		},
	];

	const getData = async () => {
		setLoading(true);
		const requestOptions = {
			method: "GET",
			headers: { "X-Auth-Token": session },
		};

		const response = await fetch(
			`${process.env.REACT_APP_API_URI}/logs`,
			requestOptions
		);
		const data = await response.json();

		if (!response.ok) {
			console.log("Something went wrong.");
		} else {
			setLogs(data.logs);
			setMeta(data.meta);
		}
		setLoading(false);
	};

	const search = (e) => {
		e.preventDefault();
		var newSearch = { ...searchParams };
		searchFields.map((field) => {
			if (field.value !== "") {
				newSearch[field.key] = field.value;
			} else {
				delete newSearch[field.key];
			}
		});
		setSearchParams(newSearch);
		setFilterModal(false);
	};

	const removeFilter = (e, func, key) => {
		e.preventDefault();
		func("");
		var newSearch = { ...searchParams };
		searchFields.map((field) => {
			if (field.value !== "" && field.key !== key) {
				newSearch[field.key] = field.value;
			} else {
				delete newSearch[field.key];
			}
		});
		setSearchParams(newSearch);
	};

	const clearFilters = (e) => {
		e.preventDefault();
		setSearchParams({});
		filterFields.map((field) => {
			field.edit(field.defaultVal);
		});
	};

	useEffect(() => {
		document.title = "Logs | Pisara Dashboard";
		getData();
	}, []);

	return (
		<Container className="gx-5">
			<Row className="content-header flex-row-left mb-20">
				<Col>
					<h1 className="text-xl m-0">Logs</h1>
				</Col>
			</Row>
			<Row className="flex-row-left mb-20">
				<Col className="col-5">
					<Form onSubmit={search}>
						<div className="search-container bg-white flex-row-left">
							<i className="ri-search-line search-icon" />
							<Form.Control
								className="text-sm"
								placeholder="Search logs"
								value={searchQ}
								onChange={(e) => setSearchQ(e.target.value)}
							/>
							<Button
								variant="light"
								className="filter-btn flex-column"
								onClick={() => setFilterModal(true)}
							>
								<i className="ri-equalizer-3-fill m-0" />
							</Button>
						</div>
					</Form>
				</Col>
				<Col className="col-7 flex-row-right">
					<Pagination
						meta={meta}
						searchParams={searchParams}
						setSearchParams={setSearchParams}
						searchFields={searchFields}
						className="pull-right flex-row-left"
					/>
					<Button
						variant="light"
						className="refresh-btn flex-column"
						onClick={getData}
					>
						<i className="ri-restart-line opacity-7" />
					</Button>
					<Button className="control-btn btn-sm btn-default text-medium-gotham text-sm">
						<i className="ri-download-2-line" />
						Export
					</Button>
				</Col>
			</Row>
			<Row className="content-table-header bg-white gx-0">
				<Col className="p-10">
					<span className="text-sm text-medium-gotham mb-10 block">
						Date & Time
					</span>
				</Col>
				{/* <Col className="p-10">
					<span className="text-sm text-medium-gotham mb-10 block">Time</span>
				</Col> */}
				<Col className="p-10">
					<span className="text-sm text-medium-gotham mb-10 block">Name</span>
				</Col>
				<Col className="p-10">
					<span className="text-sm text-medium-gotham mb-10 block">Group</span>
				</Col>
				<Col className="p-10">
					<span className="text-sm text-medium-gotham mb-10 block">Device</span>
				</Col>
				<Col className="p-10">
					<span className="text-sm text-medium-gotham mb-10 block">Type</span>
				</Col>
			</Row>
			{loading ? (
				<PageLoader className="bg-white p-50" />
			) : logs?.length === 0 ? (
				<Empty label="No logs to show." className="bg-white" />
			) : (
				logs.map((log) => (
					<Row className="content-table-item bg-white gx-0">
						<Col className="p-10 ellipsis">
							<span className="text-sm">
								{format(new Date(log.created_at), "PP")}{" "}
								{format(new Date(log.created_at), "p")}
							</span>
						</Col>
						{/* <Col className="p-10 ellipsis">
							<span className="text-sm">
								{format(new Date(log.created_at), "p")}
							</span>
						</Col> */}
						<Col className="p-10 ellipsis">
							{log.group === "Students" && (
								<span className="text-sm">{log.student?.name}</span>
							)}
							{log.group === "Personnel" && (
								<span className="text-sm">{log.personnel?.name}</span>
							)}
						</Col>
						<Col className="p-10 ellipsis">
							<span className="text-sm">{log.group}</span>
						</Col>
						<Col className="p-10 ellipsis">
							<span className="text-sm">{log.device_name}</span>
						</Col>
						<Col className="p-10 ellipsis">
							<span className="text-sm">{log.direction}</span>
						</Col>
					</Row>
				))
			)}
		</Container>
	);
};

export default Logs;
